import {
  required,
  validDate,
  noFutureDate,
  minBirthDate,
} from "@origin-digital/validation";
import { RuleProps } from "./types";

const ERROR_MSG_REQUIRED = "Oops, please enter your date of birth.";
const ERROR_MSG_VALID_DATE = `Oops, that’s not a valid date of birth.`;
const ERROR_MSG_NO_FUTURE_DATE = "Oops, that date is in the future.";
const ERROR_MSG_MIN_BIRTH_DATE =
  "Sorry, Origin customers must be 18 years or older.";

export const validator = (rules?: RuleProps) => (value: string) => {
  try {
    let error: string | undefined | void;
    if (rules?.required) {
      error = error || required({ error: ERROR_MSG_REQUIRED })(value);
    }
    if (rules?.noInvalidDate) {
      error = error || validDate({ error: ERROR_MSG_VALID_DATE })(value);
    }
    if (rules?.noFuture) {
      error = error || noFutureDate({ error: ERROR_MSG_NO_FUTURE_DATE })(value);
    }
    if (rules?.noKids) {
      error =
        error ||
        minBirthDate({ minAge: 18, error: ERROR_MSG_MIN_BIRTH_DATE })(value);
    }
    return error || "";
  } catch (e) {
    console.log(e);
    return "";
  }
};
